import React, { useState } from "react";
import { Box, Container, Typography, IconButton } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import foto1 from "../../assets/images/first.jpg";
import foto2 from "../../assets/images/second.jpeg";
import foto3 from "../../assets/images/third.jpeg";

const carouselImages = [{ url: foto1 }, { url: foto2 }, { url: foto3 }];

const StudyLocally = () => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const videoUrl =
    "https://www.youtube.com/embed/QrYEcJv3PM4?autoplay=1&mute=1";

  const handlePlayVideo = () => {
    setIsVideoPlaying(true);
  };

  const handleCloseVideo = () => {
    setIsVideoPlaying(false);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === carouselImages.length - 1 ? 0 : prev + 1,
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? carouselImages.length - 1 : prev - 1,
    );
  };

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#f5f5f5",
      }}
    >
      {/* Red Background Section OR Video */}
      <Box
        sx={{
          backgroundColor: isVideoPlaying ? "#000" : "#E53935",
          pt: { xs: 8, md: 10 },
          pb: { xs: 16, md: 22 },
          position: "relative",
          transition: "all 0.5s ease",
        }}
      >
        <Container maxWidth="xl">
          {!isVideoPlaying ? (
            <>
              {/* Title */}
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: "2.5rem", md: "4rem", lg: "5rem" },
                  fontWeight: 700,
                  color: "white",
                  textAlign: "center",
                  lineHeight: 1.2,
                  mb: 4,
                  fontFamily: '"Playfair Display", serif',
                }}
              >
                Study Locally
                <br />
                Transfer Globally
              </Typography>

              {/* Play Button */}
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Box
                  onClick={handlePlayVideo}
                  sx={{
                    width: { xs: 60, md: 70 },
                    height: { xs: 60, md: 70 },
                    backgroundColor: "#FFC107",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.1)",
                      boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
                    },
                  }}
                >
                  <PlayArrowIcon sx={{ fontSize: 35, color: "#1A237E" }} />
                </Box>
              </Box>
            </>
          ) : (
            // Video Player
            <Box
              sx={{
                position: "relative",
                width: "100%",
                paddingTop: "56.25%",
                backgroundColor: "#000",
              }}
            >
              <iframe
                src={videoUrl}
                referrerPolicy="strict-origin-when-cross-origin"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Video Player"
              />

            
              <Box
                onClick={handleCloseVideo}
                sx={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  width: 40,
                  height: 40,
                  backgroundColor: "rgba(0,0,0,0.7)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  zIndex: 10,
                  "&:hover": {
                    backgroundColor: "#E53935",
                    transform: "scale(1.1)",
                  },
                }}
              >
                <CloseIcon sx={{ color: "white", fontSize: 24 }} />
              </Box>
            </Box>
          )}
        </Container>
      </Box>

      {/* Full Width Carousel Section - Overlapping */}
      <Container
        maxWidth="xl"
        sx={{
          position: "relative",
          mt: { xs: -10, md: -14 },
          zIndex: 10,
          pb: 8,
        }}
      >
        <Box
          sx={{
            backgroundColor: "#1A237E",
            position: "relative",
            overflow: "hidden",
            boxShadow: "0 12px 35px rgba(0,0,0,0.2)",
            borderRadius: "8px",
            width: "100%",
            height: { xs: "350px", sm: "450px", md: "520px" },
            "&:hover .carousel-btn": { opacity: 1 },
          }}
        >
          {carouselImages.map((slide, index) => (
            <Box
              key={index}
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                opacity: currentSlide === index ? 1 : 0,
                transition: "opacity 0.7s ease-in-out",
                zIndex: currentSlide === index ? 2 : 1,
              }}
            >
              {/* Imagen local de fondo */}
              <Box
                component="img"
                src={slide.url}
                alt={`Slide ${index + 1}`}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          ))}

          {/* Flecha Izquierda */}
          <IconButton
            className="carousel-btn"
            onClick={prevSlide}
            sx={{
              position: "absolute",
              left: 24,
              top: "50%",
              transform: "translateY(-50%)",
              backgroundColor: "rgba(255,255,255,0.3)",
              color: "white",
              opacity: 0,
              transition: "all 0.3s ease",
              zIndex: 10,
              backdropFilter: "blur(4px)",
              "&:hover": { backgroundColor: "#E53935", opacity: 1 },
            }}
          >
            <ArrowBackIosNewIcon sx={{ fontSize: 22 }} />
          </IconButton>

          {/* Flecha Derecha */}
          <IconButton
            className="carousel-btn"
            onClick={nextSlide}
            sx={{
              position: "absolute",
              right: 24,
              top: "50%",
              transform: "translateY(-50%)",
              backgroundColor: "rgba(255,255,255,0.3)",
              color: "white",
              opacity: 0,
              transition: "all 0.3s ease",
              zIndex: 10,
              backdropFilter: "blur(4px)",
              "&:hover": { backgroundColor: "#E53935", opacity: 1 },
            }}
          >
            <ArrowForwardIosIcon sx={{ fontSize: 22 }} />
          </IconButton>

          {/* Puntos de Paginación en la base (Dots) */}
          <Box
            sx={{
              position: "absolute",
              bottom: 24,
              right: { xs: 24, md: 48 },
              display: "flex",
              gap: 1.5,
              zIndex: 10,
            }}
          >
            {carouselImages.map((_, index) => (
              <Box
                key={index}
                onClick={() => setCurrentSlide(index)}
                sx={{
                  width: currentSlide === index ? 32 : 10,
                  height: 10,
                  borderRadius: "5px",
                  backgroundColor:
                    currentSlide === index
                      ? "#FFC107"
                      : "rgba(255,255,255,0.5)",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                }}
              />
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default StudyLocally;
